import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const LEASING_INTEREST_SAVED = gql`
  subscription leasingInterestSaved {
    leasingInterestSaved {
      interestTypeId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
